<script setup>
import { computed } from 'vue';
import { THEMES } from '@/constants';
import { usePage } from '@inertiajs/vue3';

const page = usePage();
const context = computed(() => page.props?.context);
const theme = context.value.theme;

const props = defineProps({
  active: {
    type: Boolean,
    required: true,
  },
  ariaLabel: {
    type: String,
    required: false
  },
  id: {
    type: String,
    required: true,
  },
  tabIndex: {
    type: Number,
    default: 0
  }
});

const anchorClasses = computed(() => [
  'tab-anchor border-none pointer-events-none',
  theme == THEMES.STUDY_AUS && 'text-base md:text-2xl',
  theme == THEMES.STUDY_MELB && 'md:text-[20px] px-2 font-au-sans-medium',
  theme == THEMES.STUDY_QLD && 'text-base md:text-2xl',
]);

const activeClass = computed(() => ({
  [THEMES.STUDY_AUS]: "after:bg-primary-600 text-primary-600 after:h-1 after:mt-1",
  [THEMES.STUDY_MELB]: "text-blue-200 underline underline-offset-8 decoration-2",
  [THEMES.STUDY_QLD]: "px-1 font-bold underline underline-offset-4"
}[context.value.theme]));
</script>

<template>
  <li
    class="my-1 cursor-pointer after:content-[''] after:w-full after:rounded-3xl after:block p-1"
    :class="[active ? activeClass : '']"
    role="presentation"
  >
    <a
      :id="id"
      :tabindex="tabIndex"
      :ariaLabel="ariaLabel"
      href="#"
      :class="anchorClasses"
      role="tab"
      :aria-selected="active"
    ><slot /></a>
  </li>
</template>
